import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class CompetitionSeasonDeleted extends DomainEvent<DeletedEntity> {}
